import DialogModal from "app/game-over/DialogModal";
import PrivacyPolicy from "app/game-over/PrivacyPolicy";
import useSailthru, { getCurrentDate } from "app/game-over/useSailThru";
import IconClose from "app/icons/IconClose.js";
import cn from "app/util/classnames";
import mixpanel from "mixpanel-browser";
import { useState } from "react";
import { useLocalStorage } from "react-use";

export default function NewsletterSignupBanner() {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const { signUp } = useSailthru();

  const [subscribed, setSubscribed] = useLocalStorage<boolean>(
    "PIXELLENCE_NEWSLETTER_SUBSCRIBED",
    false,
  );

  if (subscribed) {
    return null;
  }

  function closeDialog() {
    setIsOpen(false);
    setError("");
  }

  return (
    <>
      <p className="mx-auto max-w-md height text-center text-base font-medium -tracking-[0.015em]">
        Never miss Pixellence.
        <br />
        <button
          type="button"
          className="inline appearance-none underline hover:no-underline cursor-pointer"
          onClick={() => {
            setIsOpen(true);
            mixpanel.track("email_subscribe");
          }}
        >
          Subscribe
        </button>{" "}
        for reminders.
      </p>

      <DialogModal isOpen={isOpen} onClose={closeDialog}>
        <div className="relative mx-auto my-8 grid w-full max-w-2xl bg-gameplay-bg px-6 py-8 text-center text-text">
          <button
            autoFocus
            className="absolute -top-8 end-0"
            onClick={closeDialog}
          >
            <IconClose width={32} height={32} className="cursor-pointer" />
          </button>
          <div
            className={cn(
              "col-start-1 row-start-1 flex w-full flex-col items-center justify-center gap-8 transition-opacity",
              !success ? "invisible opacity-0" : "opacity-100",
            )}
          >
            <h2 className="font-condensed text-3.5xl max-w-64 text-center font-bold uppercase leading-none -tracking-[0.015em]">
              Thank you for subscribing!
            </h2>
            <button
              type="button"
              onClick={closeDialog}
              className="h-10 w-49.5 rounded border border-text bg-text text-sm font-bold uppercase text-background"
            >
              Continue
            </button>
          </div>
          <form
            className={cn(
              "col-start-1 row-start-1 flex w-full flex-col items-center gap-8 border-0",
              success && "invisible",
            )}
            onSubmit={(e) => {
              e.preventDefault();
              setError("");

              try {
                const today = getCurrentDate();
                const formData = new FormData(e.target as HTMLFormElement);

                signUp({
                  email: formData.get("email") as string,
                  lists: {
                    "Master List": 1,
                    TED_Games_daily: 1,
                    TED_Games_Updates: 1,
                  },
                  vars: {
                    ted_games_daily_optin_date: today,
                    ted_games_daily_source: "pixellence",
                    ted_games_updates_optin_date: today,
                    ted_games_updates_source: "pixellence",
                  },
                  onSuccess: () => {
                    setSuccess(true);
                    setSubscribed(true);
                  },
                  onError: (error) => {
                    console.error("SailThru signup error:", error);
                    setError(`${error}`);
                  },
                });
              } catch (error) {
                setError(`${error}`);
              }
            }}
          >
            <h2 className="text-[2.5rem] lg:text-[3.5rem] font-bold uppercase leading-none -tracking-[0.015em]">
              Pixellence Reminders
            </h2>

            <p className="mx-auto max-w-lg text-lg font-bold uppercase tracking-[0.03em]">
              Receive daily Pixellence reminders and stay informed about the
              latest from TED
            </p>

            <input
              aria-label="Email"
              name="email"
              type="email"
              id="email"
              placeholder="What's your email?"
              required
              onChange={() => setError("")}
              className="mt-5 w-full max-w-sm appearance-none border-b-2 border-text bg-transparent p-2 text-center placeholder:text-text"
              aria-labelledby="email-error"
            />
            <label
              id="email-error"
              className={cn(
                "py-1 text-center text-xs font-medium -tracking-[0.01em] text-text",
                !error && "absolute opacity-0",
              )}
            >
              {error}
            </label>

            <button className="h-10 w-full max-w-80 rounded border border-text bg-gameplay-bg text-sm font-bold uppercase text-background cursor-pointer">
              Subscribe
            </button>
            <PrivacyPolicy />
          </form>
        </div>
      </DialogModal>
    </>
  );
}
